import { ArrowBackFilledIcon, ArrowNextFilledIcon } from '@backend/lib-design-system/icons';
import { css, styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const Wrapper = styled.div`
  position: relative;
  padding: 64px 0;
  margin: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    background-color: #f8f8f8;
  }

  ${getMediaQuery('tablet')} {
    padding: 3rem 0;
  }

  ${getMediaQuery('mobile')} {
    padding: 2rem 0;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  padding: 0;

  ${getMediaQuery('tablet')} {
    padding: 0 4rem;
  }

  ${getMediaQuery('mobile')} {
    padding: 0 1rem;
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 2.5rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  /* centers a row narrower than the screen; unlike justify-content, the margins drop to 0 once the row
     overflows, so its first cards stay reachable by scrolling */
  & > :first-child {
    margin-left: auto;
  }

  & > :last-child {
    margin-right: auto;
  }

  ${getMediaQuery('mobile', 'tablet')} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    overflow-x: visible;

    & > :first-child,
    & > :last-child {
      margin: 0;
    }
  }

  ${getMediaQuery('mobile')} {
    grid-template-columns: 1fr;
  }
`;

// a paginated list shows every offer of the page: the next page starts after them
export const CardWrapper = styled.div<{ $showAll: boolean }>`
  flex: 0 0 auto;
  max-width: 22.1875rem;
  width: 100%;

  ${getMediaQuery('mobile', 'tablet')} {
    max-width: none;

    &:nth-child(n + 5) {
      display: ${({ $showAll }) => ($showAll ? 'block' : 'none')};
    }
  }

  ${getMediaQuery('tablet')} {
    &:only-child {
      grid-column: 1 / -1;
      justify-self: center;
      max-width: 22.1875rem;
    }
  }
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-right: 4rem;
  margin-bottom: 1rem;

  ${getMediaQuery('mobile', 'tablet')} {
    display: none;
  }
`;

// a button, not a clickable icon: screen readers announce it and the keyboard reaches it
export const NavigationButton = styled.button`
  display: flex;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

const navigationIconStyle = css`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.alpha};
  }
  & > svg {
    width: 0.9375rem;
    height: 0.9375rem;
  }
`;

export const NavigationBackStyledIcon = styled(ArrowBackFilledIcon)`
  ${navigationIconStyle}
`;

export const NavigationNextStyledIcon = styled(ArrowNextFilledIcon)`
  ${navigationIconStyle}
`;

export const PaginationContainer = styled.div`
  margin-top: 2rem;
`;

export const ButtonContainer = styled.div`
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;
`;
